import { Component, DestroyRef, computed, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router
} from '@angular/router';

/**
 * Full-screen overlay while a route navigation is in progress (including lazy-loaded chunks).
 * Mount once at app root next to {@link RouterOutlet}.
 */
@Component({
  standalone: true,
  selector: 'app-navigation-loader',
  templateUrl: './navigation-loader.component.html',
  styleUrl: './navigation-loader.component.scss'
})
export class NavigationLoaderComponent {
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);
  private readonly pendingNavigations = signal(0);

  readonly isActive = computed(() => this.pendingNavigations() > 0);

  constructor() {
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.pendingNavigations.update((count) => count + 1);
        return;
      }

      if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.pendingNavigations.update((count) => Math.max(0, count - 1));
      }
    });
  }
}
